import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UiWorkoutListCardComponent } from './ui-workout-list-card/ui-workout-list-card.component';
import { UiThemeModule } from '@fitscovery/partner-web/ui/theme';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { UiLoadMoreButtonModule } from '@fitscovery/partner-web/workouts/ui/load-more-button';
import { PartnerWebSharedUiBeAMemberButtonModule } from '@fitscovery/partner-web/workouts/ui/be-a-member-button';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    CommonModule,
    UiThemeModule,
    TranslateModule,
    FontAwesomeModule,
    NgxSkeletonLoaderModule,
    UiLoadMoreButtonModule,
    PartnerWebSharedUiBeAMemberButtonModule
  ],
  declarations: [UiWorkoutListCardComponent],
  exports: [UiWorkoutListCardComponent]
})
export class WorkoutsPartnerWebUiWorkoutListCardModule { }
